import type { TicketStatus } from '@beacon/core';
import { Dropdown } from '@/components/ui/dropdown.js';
import { Status } from './status.js';

const STATUSES: TicketStatus[] = [
  'new',
  'triaged',
  'in_progress',
  'awaiting_client',
  'resolved',
  'closed',
];

export function StatusDropdown({
  value,
  onChange,
  disabled = false,
}: {
  value: TicketStatus;
  onChange: (next: TicketStatus) => void;
  disabled?: boolean;
}) {
  return (
    <Dropdown<TicketStatus>
      value={value}
      onChange={onChange}
      ariaLabel="Change status"
      items={STATUSES.map((s) => ({
        value: s,
        label: <Status s={s} />,
        disabled,
      }))}
      renderTrigger={(item) => item && <Status s={item.value} />}
    />
  );
}
